module.exports = __webpack_public_path__ + "static/media/dodgem(23).8af4860f.PNG";